<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="changeTab1(1)"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="changeTab1(2)"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="changeTab1(3)"
            >{{ $t("m.options.listTab.star") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 4 }"
            @click="changeTab1(4)"
            >{{ $t("m.options.listTab.model") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <div class="box-content">
          <div
            @click="checkDevice(item)"
            :class="[
              item.report.id == activeCurveId
                ? 'box-item box-half box-active'
                : 'box-item box-half',
            ]"
            v-for="item in reportList"
            v-bind:key="item.report.id"
          >
            <!--<div class="box-state box-state-1"></div>-->
            <div class="box-item-img">
              <img src="../../assets/img/编组18@2x.png" />
              <div class="datetime">
                <el-rate
                  :colors="['#FC9153', '#FC9153', '#FC9153']"
                  v-model="item.report.level"
                ></el-rate>
              </div>
            </div>
            <div class="box-item-text">
              <div>
                <span class="text-title">{{ $t("m.chart.table.name") }}：</span
                ><span class="text-value">{{ item.report.name }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.chart.table.duration") }}：</span
                ><span class="text-value">{{
                  item.reportVo.suitVo.suit.hbtime
                }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.chart.table.machineName") }}：</span
                ><span class="text-value">{{
                  item.reportVo.suitVo.device == null
                    ? "无"
                    : item.reportVo.suitVo.deviceType
                }}</span>
              </div>
              <div>
                <span class="text-title">{{ $t("m.chart.table.date") }}：</span
                ><span class="text-value">{{
                  $moment(Number(item.report.createtime)).format("YYYY-MM-DD")
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-footer">
          <el-pagination
              v-show="reportPage.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="curvePageChange"
              :page-size="reportPage.pageSize"
              :total="reportPage.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="main-box border-1px-all">
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="activeCurveId"
        :key="activeCurveId"
        :show-name="true"
      ></report-chart>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <el-select v-model="searchParamKey" style="width: 140px;" placeholder="">
        <el-option
                v-for="item in searchParamsKeyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
      </el-select>
      <div>
        <div class="flex flex-center flex-between" style="margin-top:10px;">
          <el-input
            v-model="searchParamValue"
            :placeholder="$t('m.chart.table.placeholder3')"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="searchClick" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import report from "@/components-online/curve/report";
var jsonFileStr = "";

export default {
  name: "curveList",
  components: {
    "report-chart": report,
  },
  data() {
    return {
      searchParamValue: "", //搜索框输入的值
      searchParamKey: "name",
      searchParamsKeyOptions: [
        {
          value: "name",
          label: "报告名称",
          url: "/manage/report/searchAllByName.do",
        },
        {
          value: "level",
          label: "报告等级",
          url: "/manage/report/searchByLevel.do",
        },
      ],
      reportPage: {
        total: 0,
        pageSize: 100,
        pageNum: 1,
      },
      reportList: [],
      reportDetailDialog: false,
      reportKey: 0,
      selectReportId: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      url: "/manage/report/getOnlyListByUser.do",
      searchUrl: {
        trainUrl: "/manage/report/getOnlyListTrainByUser.do",
        manuUrl: "/manage/report/getOnlyListManuByUser.do",
        importUrl: "/manage/report/getOnlyListImportByUser.do",
        searchByNameUrl: "/manage/report/searchSharedByName.do",
      },
      selectReportIds: [],
      importShow: 0,
      loading: undefined,
      importReportDialog: false,
      addReportForm: {
        name: "",
        note: "",
      },
      importReportInfo: "",
      selectSuitId: 0,
      reportCommentListDialog: false,
      reportCommentList: [],
      reportCommentPage: {
        pageSize: 20000,
        pageNum: 1,
        total: 0,
      },
      selectCommentId: 0,
      refreshCommentDetail: false,
      commentDetailDialog: false,
      addCommentDialog: false,
      refreshAddComment: false,
      importFileJson: {},
      activeCurveId: 0,

      active1: 1,
      star: 2,
      dialogTableVisible: false,
    };
  },
  mounted() {
    //this.loadReportList()
    this.changeTab1(1);
  },
  watch: {
    $route(to) {
      if (to.path === "on-curveList") {
        this.changeTab1(1);
      }
    },
  },
  methods: {
    changeTab1(tab) {
      console.info("获取曲线列表");
      var url = "/manage/report/orderByCreateTime.do";
      var sortType = 1;
      var active = 1;
      if (tab == 1) {
        url = "/manage/report/orderByCreateTime.do";
        sortType = 2;
        active = 1;
      } else if (tab == 2) {
        url = "/manage/report/orderByName.do";
        sortType = 1;
        active = 2;
      } else if (tab == 3) {
        url = "/manage/report/orderByLevel.do";
        sortType = 2;
        active = 3;
      } else if (tab == 4) {
        url = "/manage/report/orderByDeviceType.do";
        sortType = 2;
        active = 4;
      }
      this.active1 = active;
      this.importShow = 0;
      this.$http
        .get(url, {
          params: {
            sortType: sortType,
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.reportList = resp.data.data.list;
            this.reportPage.total = resp.data.data.total;
            this.activeCurveId = resp.data.data.list[0].report.id;
            //console.info(resp)
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    loadReportList() {
      this.importShow = 0;
      this.$http
        .get(this.url, {
          params: {
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.reportList = resp.data.data.list;
            this.reportPage.total = resp.data.data.total;

            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
               background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading = loading;
            this.activeCurveId = resp.data.data.list[0].report.id;
            //console.info(resp)
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    searchClick() {
      if (this.searchParamValue.trim().length > 0) {
        if (this.searchParamKey == "name") {
          this.$http
            .get("/manage/report/searchAllByName.do", {
              params: {
                name: this.searchParamValue,
                pageSize: this.reportPage.pageSize,
                pageNum: this.reportPage.pageNum,
              },
            })
            .then(
              function(resp) {
                this.reportList = resp.data.data.list;
                this.reportPage.total = resp.data.data.total;
                this.activeCurveId = resp.data.data.list[0].report.id;
                this.dialogTableVisible = false;
              }.bind(this)
            )
            .catch((err) => err);
        } else if (this.searchParamKey == "level") {
          this.$http
            .get("/manage/report/searchByLevel.do", {
              params: {
                level: this.searchParamValue,
                pageSize: this.reportPage.pageSize,
                pageNum: this.reportPage.pageNum,
              },
            })
            .then(
              function(resp) {
                this.reportList = resp.data.data.list;
                this.reportPage.total = resp.data.data.total;
                this.activeCurveId = resp.data.data.list[0].report.id;
                this.dialogTableVisible = false;
              }.bind(this)
            )
            .catch((err) => err);
        }
      } else {
        this.$message.error(
          this.$i18n.locale === "en-US" ? "Please enter the name" : "请输入名称"
        );
      }
    },
    checkDevice(item) {
      /*const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: '#fc9153'
                });
                this.loading = loading*/
      this.activeCurveId = item.report.id;
    },
    reportDetailLoadingFinish() {
      //this.loading.close()
    },
    importReport() {
      let url =
        "/manage/report/importReportMulti.do?name=" +
        this.addReportForm.name +
        "&note=" +
        this.addReportForm.note;
      this.$http.defaults.withCredentials = true;
      console.info("添加的数据" + this.importReportInfo);
      console.info("添加的数据" + this.importFileJson);
      console.info("添加的数据" + jsonFileStr);
      this.$http
        .post(url, jsonFileStr)
        .then(
          function(response) {
            if (response.data.success) {
              this.$message.success(this.$t("m.alert.updateSuccess"));
              this.importReportDialog = false;
              this.loadReportList();
            } else {
              this.$message.error(response.data.msg);
            }
            this.addReportForm.name = "";
            this.addReportForm.note = "";
            this.$refs.reportFileUpload.clearFiles();
          }.bind(this)
        )
        .catch((err) => err);
    },
    fileChange(file, fileList) {
      console.info(file);
      console.info(fileList);
      // var selectedFile = document.getElementById("files").files[0];//获取读取的File对象
      let reader = new FileReader(); //这里是核心！！！读取操作就是由它完成的。
      reader.readAsText(file.raw); //读取文件的内容
      reader.onload = function() {
        // console.log("读取结果：", this.result);//当读取完成之后会回调这个函数，然后此时文件的内容存储到了result中。直接操作即可。
        this.importReportInfo = JSON.parse(this.result);
        this.importFileJson = JSON.parse(this.result);
        jsonFileStr = JSON.parse(this.result);
        console.info(this.importReportInfo);
        console.info(this.importFileJson);
      };
    },
    curvePageChange(val) {
      console.info(val);
      this.reportPage.pageNum = val;
      this.changeTab1(this.active1);
    },
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
</style>
